import { render, staticRenderFns } from "./loader-comp.vue?vue&type=template&id=34560812&scoped=true"
import script from "./loader-comp.vue?vue&type=script&lang=js"
export * from "./loader-comp.vue?vue&type=script&lang=js"
import style0 from "./loader-comp.vue?vue&type=style&index=0&id=34560812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34560812",
  null
  
)

export default component.exports